module.exports = __webpack_public_path__ + "img/phone.7a57452a.png";